import { render, staticRenderFns } from "./CustomStat.vue?vue&type=template&id=887e37d2"
import script from "./CustomStat.vue?vue&type=script&lang=js"
export * from "./CustomStat.vue?vue&type=script&lang=js"
import style0 from "./CustomStat.vue?vue&type=style&index=0&id=887e37d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports